// import './App.css';
import "./styles/styles.scss";
import logo1 from "./imagens/Logo 1.png";
import atendimento from "./imagens/atendimento.icon.png";
import defesa from "./imagens/defesa.icon.png";
import explicacoes from "./imagens/explicações.icon.png";
import divorcio from "./imagens/divorcio.png.png";
import guarda from "./imagens/guarda.png.png";
import pensão from "./imagens/pensão.png.png";
import explicacao from "./imagens/explicacao.png";
import fotoLaura from "./imagens/foto-Laura.png";

function App() {
  return (
    <div className="App">
      <section className="sessao1">
        <aside className="sessao1-content">
          <img src={logo1} alt="Logo Laura giacomini"></img>
          <h1>
            Advocacia especializada<br></br> na defesa de mães e<br></br>{" "}
            mulheres
          </h1>
          <p>
            Suporte jurídico completo e personalizado, realizado<br></br> por
            uma <span>especialista em direito de família</span>, com<br></br>{" "}
            atendimento em <span>todo o Brasil</span>.
          </p>
          <a href="https://wa.me/5555999071999" target="_blank">
            Agendar minha consulta
          </a>
        </aside>
      </section>

      <section className="sessao2">
        <div className="card">
          <img src={atendimento}></img>
          <div>
            <h2>Suporte Exclusivo</h2>
            <p>
              {" "}
              <span>Análise detalhada</span> e{" "}
              <span>
                atendimento<br></br> único{" "}
              </span>
              para atender às{" "}
              <span>
                suas <br></br> necessidades
              </span>{" "}
              específicas,<br></br> onde quer que você esteja.
            </p>
          </div>
        </div>

        <div className="card">
          <img src={defesa}></img>
          <div>
            <h2>Defesa Dedicada</h2>

            <p>
              {" "}
              <span> Compromisso firme</span> em{" "}
              <span>
                proteger<br></br> seus direitos e os de seus filhos,<br></br>{" "}
              </span>
              enfrentando desafios jurídicos<br></br> com determinação e
              expertise.
            </p>
          </div>
        </div>

        <div className="card">
          <img src={explicacoes}></img>
          <div>
            <h2>Explicações Claras</h2>
            <p>
              {" "}
              <span> Informações acessíveis e detalhadas</span> <br></br>sobre
              seus direitos, para que você tome decisões seguras e conscientes.
            </p>
          </div>
        </div>
      </section>

      <section className="sessao3">
        <h1>
          Se você é mãe ou mulher e está em busca<br></br> de proteção e
          garantia dos seus direitos
        </h1>

        <div className="border">
          <h2>você está no lugar certo!</h2>
        </div>
        {/* <div className='svg-container-left'>
          <svg viewBox="0 0 100 10" preserveAspectRatio="none">
            <path d="M0,5 C10,15 20,-5 30,5 C40,15 50,-5 60,5 C70,15 80,-5 90,5 100,9" fill="transparent" stroke="#F7F0DE" stroke-width="0.5" />
          </svg>
        </div>

        <div className='svg-container-right'>
          <svg viewBox="0 0 100 10" preserveAspectRatio="none">
            <path d="M0,5 C2,12 10,-2 30,8 C40,15 50,-5 60,5 C70,15 80,-5 90,5 98,9"
              fill="transparent" stroke="#F7F0DE" stroke-width="0.5" />
          </svg>
        </div> */}
      </section>

      <section className="sessao4">
        <div className="sessao4-content">
          <div>
            <div className="item">
              <div className="circle">
                <img src={divorcio}></img>
              </div>
              <h3>
                Divórcio <br></br> ou separação
              </h3>
            </div>

            <div className="item">
              <div className="circle">
                <img src={guarda}></img>
              </div>
              <h3>
                Guarda <br></br> de filhos
              </h3>
            </div>
          </div>
          <div>
            <div className="item">
              <div className="circle">
                <img src={pensão}></img>
              </div>
              <h3>
                Pensão <br></br> alimentícia
              </h3>
            </div>

            <div className="item">
              <div className="circle">
                <img src={explicacao}></img>
              </div>
              <h3>
                Regulamentação <br></br>de visitas
              </h3>
            </div>
          </div>
        </div>

        <a href="https://wa.me/5555999071999" target="_blank">
          Falar com especialista
        </a>
      </section>

      <section className="sessao5">
        <aside className="sessao5-content">
          <div className="sessao5-content-left">
            <img src={fotoLaura}></img>
            <div className="id">
              <h3>Laura Giacomini dos Santos</h3>
              <p>
                Formada em Direito e Pós-graduada <br></br> em Direito das
                Famílias e Sucessões
              </p>
            </div>
          </div>
          <div className="sessao5-content-right">
            <h2>
              Como
              <span>
                {" "}
                advogada especialista em Direito de <br className="queda"></br>Família
              </span>
              , ofereço um suporte jurídico e <br></br> estratégico e
              personalizado, cuidando <br></br> de cada detalhe para proteger o
              que<br></br> mais importa: <span>você e sua família</span>.
            </h2>
            <p className="p5">
              Entendo as complexidades e desafios que mães e <br></br>mulheres
              enfrentam e estou aqui para assegurar<br></br>
              que{" "}
              <span>
                {" "}
                você recebá a orientação e a defesa necessária<br></br>
              </span>{" "}
              para <span> proteger o que é mais importante para você</span>.
            </p>

            <a href="https://wa.me/5555999071999" target="_blank">
              Falar com especialista
            </a>
          </div>
        </aside>
      </section>

      <section className="sessao6">
        <div className="sessao6-content">
          <h1>
            <span>Não espere mais para</span>
            <br></br> garantir seus direitos<br></br> e os de seus filhos.
          </h1>
          <div className="paragrafo">
            <p>
              Agende sua consulta e dê o<br></br> primeiro passo rumo a um
              futuro<br></br> mais tranquilo,{" "}
              <span>
                protegendo o que<br></br> mais importa para você
              </span>
              .
            </p>
          </div>
          <a href="https://wa.me/5555999071999" target="_blank">
            Agendar minha consulta agora
          </a>
        </div>
      </section>

      <footer>
        <h3>Todos os direitos reservados Laura Giacomini © 2025</h3>
      </footer>
    </div>
  );
}

export default App;
